import { Transition } from "@uirouter/react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { UsersDTO } from "../../store/users/models/dto";
import { UsersService } from "../../store/users/service";
import { LeafRole } from "../../utils/and-or-tree";
import { UserDetail } from "../users/detail";
import { names as userNames } from "../users/route-names";
import { MerchantsComponent } from "./all";
import { NewMerchantPage } from "./new";
import { names } from "./route-names";

const states: MenuRoute[] = [
  {
    name: names.all,
    component: MerchantsComponent,
    url: "/merchants/",
    data: {
      title: "merchants",
    },
  },
  {
    name: names.new,
    component: NewMerchantPage,
    url: "/merchants/new",
    data: {
      title: "new-merchant",
    },
  },
  {
    name: names.single,
    component: UserDetail,
    url: "/merchants/:id",
    data: {
      title: "merchant-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "id",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) => UsersService.getMerchant(id),
      },
    ],
    redirectTo: (trans: Transition) => {
      // getAsync tells the resolve to load
      let resolvePromise: Promise<
        UsersDTO.Responses.GetSingle.T | Error
      > = trans.injector().getAsync("item");
      return resolvePromise.then((x) => {
        return x instanceof Error
          ? names.all
          : x.roleDetails.roles.includes("ROLE_MERCHANT")
          ? undefined
          : userNames.single;
      });
    },
  },
];

export const sidebar: MenuNode.MenuNode = {
  icon: "userProfile",
  title: "merchants",
  children: [
    { icon: "userProfile", route: states[0] },
    { icon: "userProfile", route: states[1] },
  ],
  roles: new LeafRole("ROLE_ADMIN"),
};

export const MerchantsRoutes = {
  names,
  states,
  sidebar,
};
